/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Contact_TitleInputs */

const es_tyc_contact_title = /** @type {(inputs: Tyc_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Contacto`)
};

const en_tyc_contact_title = /** @type {(inputs: Tyc_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Contact`)
};

/**
* | output |
* | --- |
* | "11. Contact" |
*
* @param {Tyc_Contact_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_contact_title = /** @type {((inputs?: Tyc_Contact_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Contact_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_contact_title(inputs)
	return en_tyc_contact_title(inputs)
});
export { tyc_contact_title as "tyc.contact.title" }